// extracted by mini-css-extract-plugin
export default {"button":"Button2_button__jUzpJ","button--inverse":"Button2_button--inverse__EA-8e"};